/* eslint-disable max-len */

import * as R from 'ramda';

const library = require('@safe-systems/ss-ui-components');

const { copy } = library;

export default function EditInherentRiskProfileDialogController(
  $filter,
  $q,
  $rootScope,
  $scope,

  alerts,
  ecatDataService,
  ecatSharedModelService,
  loaderService,

  ssDialogService
) {
  const vm = this;

  vm.activeTemplate = ecatSharedModelService.getActiveTemplate(ecatSharedModelService.templates);
  vm.activeCategory = vm.activeTemplate.inherentRiskProfiles[0].categories[0];

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleNavToCategory = _handleNavToCategory;
  vm.handleFormSubmit = _handleFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    loaderService.showViewLoader = false;
    return _setInputs().then(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** ***************************************
   * Event Functions
   */

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleNavToCategory(categoryId) {
    const newActiveCategory = $filter('filter')(
      ecatSharedModelService.getActiveTemplate(ecatSharedModelService.templates).inherentRiskProfiles[0].categories,
      { categoryId }
    )[0];

    vm.activeCategory = newActiveCategory;
    angular.element('.ecat--perform-assessment-categories-pane')[0].scrollTop = 0;
  }

  function _handleFormSubmit() {
    loaderService.showViewLoader = true;
    $rootScope.$broadcast('clearECATInherentRiskProfile', { assessmentId: vm.assessmentId });
    _performSave().then(
      () => {
        alerts.success(copy.advisory.ecat.alerts.saveAssessmentProgressSuccessful.text);
      },
      () => {
        alerts.error(copy.advisory.ecat.alerts.saveAssessmentProgressError.text);
      }
    ).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** ***************************************
   * Private Functions
   */

  function _setInputs() {
    const dfdSetInputs = $q.defer();
    const dfdSetCategoryFactors = $q.defer();

    R.forEach((category, categoryIndex) => {
      const templateCategory = $filter('filter')(vm.activeTemplate.inherentRiskProfiles[0].categories, { categoryId: category.categoryId })[0];
      templateCategory.numCompleted = 0;
      R.forEach((categoryFactor, categoryFactorIndex) => {
        if ((categoryFactor.inherentRiskAssessments) && (categoryFactor.inherentRiskAssessments.length > 0)) {
          const templateCategoryFactor = $filter('filter')(templateCategory.categoryFactors, { categoryFactorId: categoryFactor.categoryFactorId })[0];
          templateCategoryFactor.newValue = categoryFactor.inherentRiskAssessments[0].categoryFactorOptionId;
          templateCategoryFactor.newNotes = categoryFactor.inherentRiskAssessments[0].notes;
          templateCategoryFactor.notificationText = categoryFactor.notificationText;
          templateCategory.numCompleted += 1;
        }
        if ((categoryIndex === vm.inherentRiskProfile.categories.length - 1) && (categoryFactorIndex === category.categoryFactors.length - 1)) {
          dfdSetCategoryFactors.resolve();
        }
      },
      category.categoryFactors);
    },
    vm.inherentRiskProfile.categories);

    $q.all([
      dfdSetCategoryFactors.promise,
    ]).then(dfdSetInputs.resolve);

    return dfdSetInputs.promise;
  }

  function _performSave() {
    const factorOptions = _getCategoryFactorOptionsFromDialog();

    return ecatDataService.saveBulkInherentRiskAssessment(vm.assessmentId, factorOptions).then(() => {
      // If save is successful, update the UI model
      _commitFactorOptionChanges();
      $rootScope.$broadcast('refreshECATInherentRiskProfile', { assessmentId: vm.assessmentId });

      if (vm.saveType === 'saveAndClose') {
        _closeDialog();
      }
    });
  }

  function _getCategoryFactorOptionsFromDialog() {
    const inherentRiskBulkStore = [];
    R.forEach((category) => {
      const riskEntry = {
        categoryId: category.categoryId,
        categoryFactorOptions: [],
        categoryFactorNotes: [],
      };
      R.forEach((categoryFactor) => {
        if (categoryFactor.newValue) {
          riskEntry.categoryFactorOptions.push(parseInt(categoryFactor.newValue, 10));
        }
        if (categoryFactor.newNotes) {
          const entry = `${categoryFactor.newValue}_${categoryFactor.newNotes}`;
          riskEntry.categoryFactorNotes.push(entry);
        }
      },
      category.categoryFactors);
      inherentRiskBulkStore.push(riskEntry);
    },
    vm.activeTemplate.inherentRiskProfiles[0].categories);
    return inherentRiskBulkStore;
  }

  function _commitFactorOptionChanges() {
    R.forEach((category) => {
      let numCompleted = 0;
      R.forEach((categoryFactor) => {
        categoryFactor.value = categoryFactor.newValue;
        if (categoryFactor.value) {
          numCompleted += 1;
        }
      },
      category.categoryFactors);
      category.numCompleted = numCompleted;
    },
    vm.activeTemplate.inherentRiskProfiles[0].categories);
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.editInherentRiskProfileDialog);
  }
}

EditInherentRiskProfileDialogController.$inject = [
  '$filter',
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'loaderService',
  'ssDialogService'
];
